import React from 'react';
import { Bar } from "react-chartjs-2";

const optionsBar = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
        legend: {
            display: true,
            position: 'top'
        },
        tooltip: {
            callbacks: {
                label: (tooltipItem) => {
                    return tooltipItem.dataset.label + ": " + tooltipItem.parsed.x;
                }
            }
        }
    },
    scales: {
        x: {
            beginAtZero: true,
            grid: {
                display: true
            }
        },
        y: {
            grid: {
                display: false
            }
        }
    }
};

export default function ChartsBar(props) {
    return (
        <Bar data={props.data} options={optionsBar} />
    );
}
